import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useLanguage } from '../hooks/useLanguage';

const Footer: React.FC = () => {
  const { language } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="copyright">Copyright © 2002, Primus LLC. All rights reserved.</span>
        <span className="separator">|</span>
        <Link to="/">{language === 'en' ? 'Home' : '홈'}</Link>
        <span className="separator">|</span>
        <Link to="/philosophy">{language === 'en' ? 'About' : '소개'}</Link>
        <span className="separator">|</span>
        <Link to="/signature-services">{language === 'en' ? 'Services' : '서비스'}</Link>
        <span className="separator">|</span>
        <Link to="/contact">{language === 'en' ? 'Contact' : '연락처'}</Link>
      </div>
    </footer>
  );
};

export default Footer;